import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mergeArrays',
  standalone: false, // eslint-disable-line
})
export class MergeArraysPipe implements PipeTransform {
  transform(...arrays: any[][]): any[] {
    return arrays.reduce((result, current) => [...result, ...(current || [])], []);
  }
}
